import VaultBasicsFilterOptions from './VaultBasicsFilterOptions';

export default function getVaultBasicsFilterOption(filter) {
    if (filter?.vaultBasics == null) {
        return null;
    }
    if (typeof filter.vaultBasics === 'boolean') {
        return filter.vaultBasics ? VaultBasicsFilterOptions.Yes : VaultBasicsFilterOptions.No;
    }
    return null;
}
